/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';
import { getEditPriceRouteFor } from 'uplisting-frontend/utils/rhs/routes';

export default class UiBookingPriceTablesDefaultComponent extends UiBookingPriceTablesBaseComponent {
  @service router!: Services['router'];

  @cached
  get editablePriceRoute(): string {
    return (
      getEditPriceRouteFor(this.router.currentRouteName ?? '') ?? 'monthly'
    );
  }

  @cached
  get percentageForTitle(): string {
    const rentTax = this.price.rentTax as number;
    const subtotal = this.price.subtotal as number;

    return ((rentTax / subtotal) * 100).toFixed(2);
  }

  @cached
  get totalPayout(): number | null {
    const { hostEarnings, visitorLevy, visitorLevyCollectLocally } = this.price;

    if (hostEarnings === null || hostEarnings === undefined) return null;
    if (visitorLevyCollectLocally && visitorLevy) {
      return (hostEarnings as number) + (visitorLevy as number);
    }

    return hostEarnings;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::Default': typeof UiBookingPriceTablesDefaultComponent;
  }
}
